export default "__VITE_ASSET__D5T1nobC__"